module.exports = __webpack_public_path__ + "static/media/3-way-tipper.081e0458.svg";